import { environment } from "../../environments/environment";
import { Storage } from "@ionic/storage-angular";
import { Injectable } from "@angular/core";
import * as AWSCognito from "amazon-cognito-identity-js";
import { DataService } from "../data.service";
import { User } from "../models/user";
import { CognitoUserPool } from "amazon-cognito-identity-js";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  poolData: any;
  userPool: CognitoUserPool;

  constructor(
    public dataService: DataService,
    public storage: Storage,
  ) {
    this.userPool = new AWSCognito.CognitoUserPool({
      UserPoolId: environment.poolData.CognitoUserPoolId,
      ClientId: environment.poolData.CognitoClientId,
      endpoint: environment.poolData.CognitoEndpoint,
    });
  }

  signUp(username: string, password: string, given_name: string, family_name: string) {
    return new Promise((resolved, reject) => {
      const userAttribute = [];
      userAttribute.push(new AWSCognito.CognitoUserAttribute({ Name: "given_name", Value: given_name }));
      userAttribute.push(new AWSCognito.CognitoUserAttribute({ Name: "family_name", Value: family_name }));
      this.userPool.signUp(username, password, userAttribute, null, (err, result) => {
        if (err) {
          reject(err);
        } else {
          resolved(result);
        }
      });
    });
  }

  logOut(username: string) {
    return new Promise((resolved) => {
      const userData = {
        Username: username,
        Pool: this.userPool,
      };

      const cognitoUser = new AWSCognito.CognitoUser(userData);

      cognitoUser.signOut();
      resolved(true);
    });
  }

  deleteUser(email: string, password: string) {
    return new Promise((resolved, reject) => {
      const authDetails = new AWSCognito.AuthenticationDetails({
        Username: email,
        Password: password,
      });

      const userData = {
        Username: email,
        Pool: this.userPool,
      };

      const cognitoUser = new AWSCognito.CognitoUser(userData);

      cognitoUser.authenticateUser(authDetails, {
        onSuccess: () => {
          cognitoUser.deleteUser((err) => {
            if (err) {
              console.error(err, err.stack);
              reject(err);
            } else {
              resolved(true);
            }
          });
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  confirmUser(verificationCode: string, email: string) {
    return new Promise((resolved, reject) => {
      const cognitoUser = new AWSCognito.CognitoUser({
        Username: email,
        Pool: this.userPool,
      });

      cognitoUser.confirmRegistration("" + verificationCode, true, (err: TypeError, result) => {
        if (err) {
          if (err.message.indexOf("Lambda") > -1) {
            resolved(result);
          } else {
            reject(err);
          }
        } else {
          resolved(result);
        }
      });
    });
  }

  resendCode(email: string) {
    return new Promise((resolved) => {
      const cognitoUser = new AWSCognito.CognitoUser({
        Username: email,
        Pool: this.userPool,
      });

      cognitoUser.resendConfirmationCode((err) => {
        if (err) {
          console.error(err, err.stack);
        }
      });
      resolved(true);
    });
  }

  changePassword(email: string, oldPassword: string, newPassword: string) {
    return new Promise((resolved, reject) => {
      const authDetails = new AWSCognito.AuthenticationDetails({
        Username: email,
        Password: oldPassword,
      });

      const userData = {
        Username: email,
        Pool: this.userPool,
      };
      const cognitoUser = new AWSCognito.CognitoUser(userData);

      cognitoUser.authenticateUser(authDetails, {
        onSuccess: () => {
          cognitoUser.changePassword(oldPassword, newPassword, (err) => {
            if (err) {
              console.error(err, err.stack);
              reject(err);
            } else {
              resolved(true);
            }
          });
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });
  }

  forgot(email: string) {
    this.storage.set("email", email);

    const cognitoUser = new AWSCognito.CognitoUser({
      Username: email,
      Pool: this.userPool,
    });

    cognitoUser.forgotPassword({
      onSuccess: function () {},
      onFailure: function (err) {
        if (("" + err.message).indexOf("Username/client id combination not found") > -1) {
          this.presentAlert("Forgot failed", "", "Incorrect email");
        }
      },
    });
  }

  authenticate(email: string, password: string) {
    return new Promise((resolved, reject) => {
      const authDetails = new AWSCognito.AuthenticationDetails({
        Username: email,
        Password: password,
      });

      const cognitoUser = new AWSCognito.CognitoUser({
        Username: email,
        Pool: this.userPool,
      });

      // During migration of the user pool, the authentication flow type must be set to 'USER_PASSWORD_AUTH' to send the user current password to the new cognito user pool.
      cognitoUser.setAuthenticationFlowType("USER_PASSWORD_AUTH");

      cognitoUser.authenticateUser(authDetails, {
        onSuccess: (result) => {
          this.dataService.jwt = result["accessToken"]["jwtToken"];

          console.log("JWT");
          console.log(this.dataService.jwt);
          const currentUser = new User();
          const payload = result["idToken"]["payload"];
          currentUser.id = payload.sub;
          currentUser.firstname = payload.given_name;
          currentUser.lastname = payload.family_name;
          currentUser.email = payload.email;

          this.dataService.setUser(currentUser);
          this.dataService.set("user" + email, currentUser);

          resolved(result);
        },
        onFailure: (err) => {
          reject(err);
        },
        newPasswordRequired: (userAttributes) => {
          userAttributes.email = email;
          delete userAttributes.email_verified;

          cognitoUser.completeNewPasswordChallenge(password, userAttributes, {
            onSuccess(result) {},
            onFailure(error) {
              reject(error);
            },
          });
        },
      });
    });
  }

  confirmPassword(username: string, verificationCode: string, newPassword: string) {
    const cognitoUser = new AWSCognito.CognitoUser({
      Username: username,
      Pool: this.userPool,
    });

    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onFailure(err) {
          reject(err);
        },
        onSuccess(success) {
          resolve(success);
        },
      });
    });
  }
}
